var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c("confirm-insurance-modal", {
        attrs: { "company-id": _vm.confirmInsuranceCompanyId },
        model: {
          value: _vm.openConfirmDialog,
          callback: function($$v) {
            _vm.openConfirmDialog = $$v
          },
          expression: "openConfirmDialog"
        }
      }),
      _vm._v(" "),
      _c(
        "v-card-title",
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "", "align-end": "" } },
            [
              _c("v-flex", { attrs: { xs6: "" } }),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs6: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      "append-icon": "search",
                      label: "Search companies",
                      "single-line": "",
                      "hide-details": ""
                    },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          "custom-filter": _vm.filterCompanies,
          search: _vm.search,
          "rows-per-page-items": [10, 20, 30],
          items: _vm.companies
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function(slotItems) {
              return [
                _c(
                  "tr",
                  {
                    staticClass: "cursor-pointer",
                    on: {
                      click: function($event) {
                        slotItems.expanded = !slotItems.expanded
                      }
                    }
                  },
                  [
                    _c(
                      "td",
                      { staticClass: "company-id-col" },
                      [
                        _c(
                          "v-icon",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !slotItems.expanded,
                                expression: "!slotItems.expanded"
                              }
                            ],
                            staticClass: "expand-icon"
                          },
                          [_vm._v("expand_more")]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-icon",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: slotItems.expanded,
                                expression: "slotItems.expanded"
                              }
                            ],
                            staticClass: "expand-icon"
                          },
                          [_vm._v("expand_less")]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { block: "", color: "accent" },
                            on: {
                              click: function($event) {
                                return _vm.viewCompanyDetail(slotItems.item)
                              }
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              { attrs: { size: "18", color: "white" } },
                              [_vm._v("visibility")]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "pl-2" }, [
                              _vm._v("Profile")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _vm.isVerified(slotItems.item)
                          ? _c("v-icon", { attrs: { color: "green" } }, [
                              _vm._v("verified_user")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(slotItems.item.companyName))])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", [
                      _c("span", [_vm._v(_vm._s(slotItems.item.contactName))])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("span", [_vm._v(_vm._s(slotItems.item.contactPhone))])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("formatDate")(slotItems.item.created))
                        )
                      ])
                    ])
                  ]
                )
              ]
            }
          },
          {
            key: "expand",
            fn: function(slotItems) {
              return [
                _c(
                  "v-layout",
                  { attrs: { rows: "", "ml-3": "" } },
                  [
                    _c(
                      "v-layout",
                      { attrs: { column: "" } },
                      [
                        _c(
                          "v-flex",
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "caption mx-0 my-0 d-block",
                                attrs: { flat: "", color: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.viewCompanyLoads(slotItems.item)
                                  }
                                }
                              },
                              [
                                _c("v-icon", { attrs: { size: "20" } }, [
                                  _vm._v("list")
                                ]),
                                _vm._v(
                                  "\n                Loads\n              "
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "caption mx-0 my-0 d-block",
                                attrs: { flat: "", color: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.viewCompanyBids(slotItems.item)
                                  }
                                }
                              },
                              [
                                _c("v-icon", { attrs: { size: "20" } }, [
                                  _vm._v("attach_money")
                                ]),
                                _vm._v("\n                Bids\n              ")
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "caption mx-0 my-0 d-block",
                                attrs: { flat: "", color: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.viewCompanyTransactions(
                                      slotItems.item
                                    )
                                  }
                                }
                              },
                              [
                                _c("v-icon", { attrs: { size: "20" } }, [
                                  _vm._v("payment")
                                ]),
                                _vm._v(
                                  "\n                Transactions\n              "
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { column: "" } },
                      [
                        _c("company-profile-card", {
                          attrs: { "company-profile": slotItems.item }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { staticClass: "px-3 py-3", attrs: { row: "" } },
                  [
                    _c(
                      "v-flex",
                      [
                        _vm.isLtnAdmin
                          ? _c(
                              "v-btn",
                              {
                                staticClass: "accent ml-0 mr-3 my-0",
                                on: {
                                  click: function($event) {
                                    return _vm.showConfirmDialog(
                                      slotItems.item.id
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              Confirm Insurance Certificate\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01c60e49", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01c60e49","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/CompanyTable.vue
// module id = null
// module chunks = 